'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var DraggableLine = (_temp = _class = function (_Component) {
  _inherits(DraggableLine, _Component);

  function DraggableLine(props) {
    _classCallCheck(this, DraggableLine);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.startDrag = false;
    _this.canDrag = false;
    _this.offset = 0;
    _this.currentOffset = 0;
    return _this;
  }

  DraggableLine.prototype.componentDidMount = function componentDidMount() {
    this.offEvent = this.initEvent();
  };

  DraggableLine.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.offEvent) {
      this.offEvent();
    }
  };

  DraggableLine.prototype.onSelectStart = function onSelectStart(e) {
    if (this.startDrag) {
      e.preventDefault();
    }
  };

  DraggableLine.prototype.onStartMove = function onStartMove(e) {
    this.startDrag = true;
    this.canDrag = true;
    this.currentOffset = 0;
    this.offDragEvent = this.initDragEvent();
    this.startOffset = this.getClientPosition(e);
  };

  DraggableLine.prototype.onEndMove = function onEndMove() {
    if (this.startDrag) {
      if (this.offDragEvent) {
        this.offDragEvent();
      }
      this.startDrag = false;
      this.offset = this.currentOffset;
    }
  };

  DraggableLine.prototype.onDrag = function onDrag(e) {
    var _props = this.props,
        position = _props.position,
        onDrag = _props.onDrag,
        maxIncrement = _props.maxIncrement,
        maxDecrement = _props.maxDecrement;

    if (this.startDrag) {
      if (position === 'left' || position === 'top') {
        this.currentOffset = this.offset + this.startOffset - this.getClientPosition(e);
      } else {
        this.currentOffset = this.offset + this.getClientPosition(e) - this.startOffset;
      }

      if (this.currentOffset < -maxDecrement) {
        this.currentOffset = -maxDecrement;
      } else if (this.currentOffset > maxIncrement) {
        this.currentOffset = maxIncrement;
      }

      onDrag(this.currentOffset, e);
    }
  };

  DraggableLine.prototype.getClientPosition = function getClientPosition(e) {
    var position = this.props.position;

    return position === 'left' || position === 'right' ? e.clientX : e.clientY;
  };

  DraggableLine.prototype.initEvent = function initEvent() {
    var selectStart = this.onSelectStart.bind(this);
    document.addEventListener('selectstart', selectStart);
    return function () {
      return document.removeEventListener('selectstart', selectStart);
    };
  };

  DraggableLine.prototype.initDragEvent = function initDragEvent() {
    var onDrag = this.onDrag.bind(this);
    var onEndMove = this.onEndMove.bind(this);
    document.addEventListener('mousemove', onDrag);
    document.addEventListener('mouseup', onEndMove);
    return function () {
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('mouseup', onEndMove);
    };
  };

  DraggableLine.prototype.render = function render() {
    var _props2 = this.props,
        className = _props2.className,
        position = _props2.position;

    return _react2.default.createElement('div', {
      className: (0, _classnames3.default)(position === 'left' || position === 'right' ? 've-draggable-line-horizontal' : 've-draggable-line-vertical', _defineProperty({}, className, !!className)),
      onMouseDown: this.onStartMove.bind(this)
    });
  };

  return DraggableLine;
}(_react.Component), _class.displayName = 'DraggableLine', _class.propTypes = {
  onDrag: _react2.default.PropTypes.func,
  position: _react2.default.PropTypes.string,
  className: _react2.default.PropTypes.string,
  maxIncrement: _react2.default.PropTypes.number,
  maxDecrement: _react2.default.PropTypes.number
}, _class.defaultProps = {
  onDrag: function onDrag() {},

  position: 'right',
  className: '',
  maxIncrement: 9999,
  maxDecrement: 9999
}, _temp);
exports.default = DraggableLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-draggable-line@2.0.0@@ali/ve-draggable-line/build/index.js
// module id = 238
// module chunks = 0